import CRMPermission from '@/models/enums/permissions/CRMPermission'
import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/stat',
    name: 'Статистика',
    component: () => import('@/pages/Stat/StatPage.vue'),
    meta: {
      permissions: [CRMPermission.ViewStatistics],
      mobilePermissions: [CRMPermission.ViewStatisticsOnMobile],
      pageTitle: 'Статистика',
      breadcrumb: {
        label: 'Статистика',
        parent: 'Главная',
      },
    },
  },
  /// Выручка
  {
    path: '/stat/money/types',
    name: RouteName.CashSourcesStat,
    component: () => import('@/pages/Stat/Money/MoneyByPaymentTypes.vue'),
    meta: {
      permissions: [CRMPermission.ViewStatistics],
      mobilePermissions: [CRMPermission.ViewStatisticsOnMobile],
      pageTitle: 'Распределение выручки',
      layout: 'StatisticDefaultLayout',
      breadcrumb: {
        label: 'Распределение выручки',
        parent: 'Статистика',
      },
    },
  },
  {
    path: '/stat/money/revenue',
    name: RouteName.RevenueDynamicsStat,
    component: () => import('@/pages/Stat/Revenue/RevenueDynamics.vue'),
    meta: {
      permissions: [CRMPermission.ViewStatistics],
      mobilePermissions: [CRMPermission.ViewStatisticsOnMobile],
      pageTitle: 'Динамика выручки',
      layout: 'StatisticDefaultLayout',
      breadcrumb: {
        label: 'Динамика выручки',
        parent: 'Статистика',
      },
    },
  },
  /// Сотрудники
  {
    path: '/stat/work-schedules',
    name: RouteName.WorkSchedulesStat,
    component: () => import('@/pages/Stat/Staff/WorkSchedulesStat.vue'),
    meta: {
      permissions: [CRMPermission.ViewStatistics],
      mobilePermissions: [CRMPermission.ViewStatisticsOnMobile],
      breadcrumb: {
        label: 'График смен',
        parent: 'Статистика',
      },
    },
  },
  {
    path: '/stat/courier',
    name: RouteName.CourierStat,
    component: () => import('@/pages/Stat/Courier/Statistic.vue'),
    meta: {
      permissions: [CRMPermission.ViewStatistics],
      mobilePermissions: [CRMPermission.ViewStatisticsOnMobile],
      pageTitle: 'Анализ курьеров',
      layout: 'StatisticDefaultLayout',
      breadcrumb: {
        label: 'Анализ курьеров',
        parent: 'Статистика',
      },
    },
  },
  /// Блюда
  {
    path: '/stat/menu/abc',
    name: RouteName.MenuAbcStat,
    component: () => import('@/pages/Stat/Menu/AbcAnalise.vue'),
    meta: {
      permissions: [CRMPermission.ViewStatistics],
      mobilePermissions: [CRMPermission.ViewStatisticsOnMobile],
      pageTitle: 'ABC анализ блюд',
      layout: 'StatisticDefaultLayout',
      breadcrumb: {
        label: 'ABC анализ',
        parent: 'Статистика',
      },
    },
  },
  /// Агрегаторы
  {
    path: '/stat/aggregators/abc',
    name: RouteName.AggregatorsAbcStat,
    component: () => import('@/pages/Stat/Aggregator/AbcAnalysis.vue'),
    meta: {
      permissions: [CRMPermission.ViewStatistics],
      mobilePermissions: [CRMPermission.ViewStatisticsOnMobile],
      pageTitle: 'ABC анализ блюд по агрегаторам',
      layout: 'StatisticDefaultLayout',
      breadcrumb: {
        label: 'ABC анализ по агрегаторам',
        parent: 'Статистика',
      },
    },
  },
  {
    path: '/stat/aggregators/revenue',
    name: RouteName.AggregatorsRevenueDynamicsStat,
    component: () => import('@/pages/Stat/Aggregator/RevenueDynamics.vue'),
    meta: {
      permissions: [CRMPermission.ViewStatistics],
      mobilePermissions: [CRMPermission.ViewStatisticsOnMobile],
      pageTitle: 'Агрегаторы выручка и заказы',
      layout: 'StatisticDefaultLayout',
      breadcrumb: {
        label: 'Агрегаторы выручка и заказы',
        parent: 'Статистика',
      },
    },
  },
  /// Внешние коннекторы
  {
    path: '/stat/connectors/abc',
    name: RouteName.ConnectorsAbcStat,
    component: () => import('@/pages/Stat/Connectors/AbcAnalysis.vue'),
    meta: {
      pageTitle: 'ABC анализ блюд по внешним коннекторам',
      layout: 'StatisticDefaultLayout',
      breadcrumb: {
        label: 'ABC анализ по коннекторам',
        parent: 'Статистика',
      },
    },
  },
  {
    path: '/stat/connectors/revenue',
    name: RouteName.ConnectorsRevenueDynamicsStat,
    component: () => import('@/pages/Stat/Connectors/RevenueDynamics.vue'),
    meta: {
      pageTitle: 'Внешние коннекторы: выручка и заказы',
      layout: 'StatisticDefaultLayout',
      breadcrumb: {
        label: 'Коннекторы выручка и заказы',
        parent: 'Статистика',
      },
    },
  },
  /// Клиенты
  {
    path: '/stat/clients',
    name: RouteName.ClientsStat,
    component: () => import('@/pages/Stat/Client/CustomerBase.vue'),
    meta: {
      permissions: [
        CRMPermission.ViewStatistics,
        CRMPermission.ViewClientsStatistics,
      ],
      mobilePermissions: [CRMPermission.ViewStatisticsOnMobile],
      pageTitle: 'Клиентская база',
      layout: 'StatisticDefaultLayout',
      breadcrumb: {
        label: 'Клиентская база',
        parent: 'Статистика',
      },
    },
  },
  {
    path: '/stat/clients/segmentation',
    name: RouteName.ClientsSegmentationStat,
    component: () => import('@/pages/Stat/Menu/AbcAnalise.vue'),
    meta: {
      permissions: [CRMPermission.ViewStatistics],
      mobilePermissions: [CRMPermission.ViewStatisticsOnMobile],
      pageTitle: 'Клиентская база',
      layout: 'StatisticDefaultLayout',
      breadcrumb: {
        label: 'Клиентская база',
        parent: 'Статистика',
      },
    },
  },
  /// Сервис
  {
    path: '/stat/service/rating',
    name: RouteName.RatingStat,
    component: () => import('@/pages/Stat/Service/RatingStatistics.vue'),
    meta: {
      permissions: [CRMPermission.ViewStatistics],
      mobilePermissions: [CRMPermission.ViewStatisticsOnMobile],
      pageTitle: 'Рейтинг',
      layout: 'StatisticDefaultLayout',
      breadcrumb: {
        label: 'Рейтинг',
        parent: 'Статистика',
      },
    },
  },
  /// Колл-центр ///
  /// Заказы
  {
    path: '/stat/call-center/orders',
    name: RouteName.CallCenterOrdersStat,
    component: () => import('@/pages/Stat/CallCenter/OrdersStatistics.vue'),
    meta: {
      permissions: [CRMPermission.ViewStatistics],
      mobilePermissions: [CRMPermission.ViewStatisticsOnMobile],
      pageTitle: 'Заказы колл-центра',
      layout: 'StatisticDefaultLayout',
      breadcrumb: {
        label: 'Заказы колл-центра',
        parent: 'Статистика',
      },
    },
  },
  /// Филиалы
  {
    path: '/stat/call-center/filials',
    name: RouteName.CallCenterFilialsStat,
    component: () => import('@/pages/Stat/CallCenter/FilialsStatistics.vue'),
    meta: {
      permissions: [CRMPermission.ViewStatistics],
      mobilePermissions: [CRMPermission.ViewStatisticsOnMobile],
      pageTitle: 'Колл-центр',
      layout: 'StatisticDefaultLayout',
      breadcrumb: {
        label: 'Колл-центр',
        parent: 'Статистика',
      },
    },
  },
  /// Отчет по сотрудникам КЦ
  {
    path: '/stat/call-center/employees',
    name: RouteName.CallCenterEmployeesStat,
    component: () => import('@/pages/Stat/CallCenter/EmployeesStatistics.vue'),
    meta: {
      permissions: [CRMPermission.ViewStatistics],
      mobilePermissions: [CRMPermission.ViewStatisticsOnMobile],
      pageTitle: 'Отчет по сотрудникам КЦ',
      layout: 'StatisticDefaultLayout',
      breadcrumb: {
        label: 'Отчет по сотрудникам КЦ',
        parent: 'Статистика',
      },
    },
  },
  /// Безопасность / Логины
  {
    path: '/stat/login',
    name: RouteName.LoginStat,
    component: () => import('@/pages/Stat/Security/LoginStatistics.vue'),
    meta: {
      permissions: [
        CRMPermission.ViewStatistics,
        CRMPermission.ViewLoginStatistics,
      ],
      mobilePermissions: [CRMPermission.ViewStatisticsOnMobile],
      pageTitle: 'Логины и анти-фрод',
      layout: 'StatisticDefaultLayout',
      breadcrumb: {
        label: 'Логины и анти-фрод',
        parent: 'Статистика',
      },
    },
  },
  /// График смен сотрудников КЦ
  {
    path: '/stat/call-center/employees/work-schedule',
    name: RouteName.CallCenterEmployeesWorkScheduleStat,
    component: () =>
      import('@/pages/Stat/CallCenter/EmployeesWorkScheduleStatistics.vue'),
    meta: {
      permissions: [CRMPermission.ViewStatistics],
      mobilePermissions: [CRMPermission.ViewStatisticsOnMobile],
      pageTitle: 'График смен сотрудников КЦ',
      layout: 'StatisticDefaultLayout',
      breadcrumb: {
        label: 'График смен',
        parent: 'Статистика',
      },
    },
  },
]
